import { TroubleshootingStep } from '../../components/call/callExperience/callTroubleshooting';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type CallTroubleshootingState = {
  currentStep: TroubleshootingStep | null;
};

const getInitialState = (): CallTroubleshootingState => ({
  currentStep: null,
});

export const callTroubleshootingSlice = createSlice({
  name: 'callTroubleshooting',
  initialState: getInitialState(),
  reducers: {
    setCurrentStep: (
      state,
      action: PayloadAction<TroubleshootingStep | null>,
    ) => {
      return { ...state, currentStep: action.payload };
    },
    startTroubleshooting: (state) => {
      return { ...state, currentStep: TroubleshootingStep.Init };
    },
  },
});

export const { setCurrentStep, startTroubleshooting } =
  callTroubleshootingSlice.actions;
